@if (variance(); as variance) {
  <span class="whitespace-nowrap" [class.text-red-600]="variance.isHigh" [class.font-medium]="variance.isHigh">
    {{ variance.difference > 0 ? '+' : '' }}{{ variance.difference | number: '1.0-2' }} {{ unit() }}
    @if (variance.differencePercent !== null) {
      ({{ variance.differencePercent > 0 ? '+' : '' }}{{ variance.differencePercent | number: '1.0-1' }}%)
    }
  </span>
} @else {
  <span class="text-gray-400">—</span>
}
